import { render, staticRenderFns } from "./RestaurantSelector.vue?vue&type=template&id=642a94ce&scoped=true&"
import script from "./RestaurantSelector.vue?vue&type=script&lang=js&"
export * from "./RestaurantSelector.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantSelector.vue?vue&type=style&index=0&id=642a94ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642a94ce",
  null
  
)

export default component.exports